// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__3vSNe","bigColWidth":"Table_bigColWidth__3vDAD","biggerColWidth":"Table_biggerColWidth__1If-Z","row":"Table_row__zgCWM","col":"Table_col__BTuUH"};